<template>
    <div class="memmber-login-box">
        <div class="login-title">用户登录</div>
        <div class="data-list-box">
            <a-form-model
                ref="memberForm"
                :model="member"
            >
                <a-form-model-item label="手机号码(+1)" prop="phone">
                    <a-input v-model="member.phone" style="width: 100%" type="number" placeholder="请输入手机号码"/>
                </a-form-model-item>
                <a-form-model-item label="密码" prop="password">
                    <a-input v-model="member.password" type="password" style="width: 100%" autocomplete="off" placeholder="请输入密码"/>
                </a-form-model-item>
                <a-form-model-item class="submit-btn" style="border: none;">
                    <a-button type="primary" @click="submitForm('memberForm')">立即登录</a-button>
                </a-form-model-item>
            </a-form-model>
            <div class="other-box">
                <div class="link-box">
                    <router-link to="/login/register">立即注册</router-link>
                    <router-link to="/login/wechat">已有小程序账户</router-link>
                    <router-link to="/login/acc_paw">忘记密码？</router-link>
                </div>
            </div>
        </div>
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
import Tabber from '@/components/Tabber.vue'

export default {
    name: 'Login',
    components: {
        Tabber
    },
    data() {
        return {
            member: {
                phone: '',
                password: '',
            },
            codeDown: null,
            isCode: true,
            pathQuery: null,
            downNum: 60,
            path: null,
            codeCountDown: '获取验证码',
        }
    },
    created() { //视图加载前执行
        let _this = this;

    },
    mounted() {
        let _this = this;
        if (_this.$ls.get('user_account_password')) {
            _this.member = _this.$ls.get('user_account_password'); // 记住账号密码数据回填
        }
        _this.path = _this.$ls.get('currentPage');
        _this.pathQuery = _this.$ls.get('currentPageParam');
    },
    methods: {
        // 表单提交
        submitForm() {
            let _this = this;
            if (_this.member.phone == '') {
                _this.$toast.fail('请输入手机号码');
                return false;
            }
            if (_this.member.password == '') {
                _this.$toast.fail('请输入密码');
                return false;
            }
            _this._post_form('user/loginH5Pwd', {
                phone: _this.member.phone,
                password: _this.member.password,
                referee_id: _this.$ls.get('referee_id'),
            }, res => {
                _this.$ls.set('token', res.data.token);
                _this.$ls.set('user_id', res.data.user_id);
                _this.$ls.set('user_account_password', _this.member); // 记住用户账号和密码用于下一次登录
                _this.$toast.success(res.msg, {
                    onClose: _this.onClose()
                });
            })
        },

        onClose() {
            let _this = this;
            // 登陆后调回原页面
            this.$router.push({
                path: _this.path ? _this.path : '/member',
                query: _this.pathQuery ? _this.pathQuery : ''
            })
        },

        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
    }
}
</script>
<style lang="scss">
@import "./login.scss";
</style>
